<template>
    <div class="opinion">
        <form method="post" @submit.prevent="onSubmit()">
            <div class="input-group">
                <h3>您有什么想要吐槽的吗？</h3>
                <div class="row-contorl mb20">
                    <input type="text" placeholder="请输入您的主题（50字以内）" class="opinion-title" v-model.trim="title" @blur.prevent = "blurTitle">
                </div>
                <div class="row-contorl">
                    <textarea  placeholder="请输入您的反馈意见（200字以内）" class="opinion-content" v-model.trim="content" @blur.prevent = "blurContent"></textarea>
                </div>
                <div class="row-contorl check-group">
                    <div class="checkBox">
                        <input type="checkbox" v-model="checkState">
                        <div class="checkBg">
                            <i class="iconfont">&#xe62e;</i>
                        </div>
                    </div>
                    我同意和数传媒<router-link :to="{name:'feedbackView'}">《反馈条款》</router-link>
                </div>
            </div>
            <div class="btn-bar">
                <input type="submit" value="提交" class="submit" :class="{disabled:isDisabled}">
            </div>
        </form>
        <div class="m-dialog" v-show="dialog_show">
            <div class="mask"></div>
            <div class="modal">
                <div class="modal-hd">
                    感谢您的反馈
                </div>
                <div class="modal-bd">
                    我们的工作人员将根据您的反馈内容尽快处理，谢谢！
                </div>
                <div class="modal-close" @click="dialog_show = false">确认</div>
            </div>
        </div>
        <tip :msgControl="msgShow"><p slot="content">{{tipText}}</p></tip>
    </div>
</template>
<script>
import tip from '../components/tip.vue'
import {httpHead,getCookie} from '../common/util/config.js';
export default{
    data () {
        return {
            title: '',
            content: '',
            token: '',
            msgShow: false,
            tipText: '',
            checkState: false,
            titleState: false,
            contentState: false,
            isDisabled: false,
            dialog_show: false
        }
    },
    created() {
        let cookie = document.cookie;
        this.token = getCookie(cookie,'token');
        httpHead.token = this.token;
    },
    methods : {
        onSubmit () {
            if(!this.titleState || !this.contentState || !this.checkState){
                this.msg();
                this.tipText = '请填写完整后再提交'
                return false;
            }else{
                this.$post('api/opinion',{'title': this.title,'content': this.content
                })
                .then( res => {
                    if(res.code == 200){
                        this.content = '';
                        this.title = '';
                        this.dialog_show = true;
                    }else if(res.code == 222){
                        this.msg()
                        this.tipText = res.msg;
                        document.cookie = "mobile=; expires=Thu, 01 Jan 1970 00:00:00 GMT";
                        document.cookie = "name=; expires=Thu, 01 Jan 1970 00:00:00 GMT";
                        document.cookie = "token=; expires=Thu, 01 Jan 1970 00:00:00 GMT";
                        setTimeout(() => {
                            this.$router.push({ name: 'homeView'})
                        }, 2000)
                    }
                })
            }
        },
        blurTitle () {
            if(this.title == ''){
                this.msg();
                this.tipText = '请填写标题'
            }else if (this.title.length>50) {
                this.msg();
                this.tipText = '标题不能超过50字'
            }else{
                this.titleState = true
            }
        },
        blurContent () {
            if(this.content == ''){
                this.msg();
                this.tipText = '请填写反馈内容'
            }else if(this.content.length>200){
                this.msg();
                this.tipText = '反馈内容不能超过200字'
            }else{
                this.contentState = true;
            }
        },
        msg (){
            this.msgShow =true;
            clearTimeout(this.timeOut);
            this.timeOut = setTimeout(() => {
                this.msgShow =false;
            }, 2000)
        },
    },
    components : {
        tip
    }
}
</script>
<style lang="scss">
.opinion{
    .input-group{
        background:#fff;
        padding:.4rem .3rem .5rem;
        h3{
            font-size: .3rem;
            color: #4868af;
            margin-bottom: .4rem;
        }
        .opinion-title{
            width: 100%;
            border: none;
            padding: 0;
            background: #f5f5f5;
            height: .82rem;
            line-height: .82rem;
            box-sizing: border-box;
            padding-left: .22rem;
            outline: none;
            border-radius: .1rem;
        }
        .opinion-content{
            padding: .22rem;
            border: none;
            width: 100%;
            background: #f5f5f5;
            outline: none;
            font-size: .28rem;
            box-sizing: border-box;
            line-height: 1.5;
            border-radius: .1rem;
            height: 3rem;
            resize: none;
            font-family: initial;
        }
        .check-group{
            margin-top:.4rem;
            a{
                color: #3168b3;
            }
        }
    }
    .btn-bar{
        padding: 0 .3rem;
        margin-top:1rem;
        .submit{
            background: linear-gradient(to bottom, #799ff2 , #2451b3);
            border:none;
            padding:0;
            color:#fff;
            width: 100%;
            display:block;
            margin:0 auto;
            height: .8rem;
            border-radius:.4rem;
            outline: none;
            font-size:.36rem;
        }
    }
}
.m-dialog{
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index:999;
    .mask{
        position: absolute;
        top:0;
        width: 100%;
        height: 100%;
        background:rgba(0,0,0,0.6);
    }
    .modal{
        position: absolute;
        top: 50%;
        left: 50%;
        background: #fff;
        width: 85%;
        padding: .5rem;
        box-sizing: border-box;
        text-align: center;
        transform: translate(-50%,-50%);
        .modal-hd{
            font-size: .36rem;
            color: #333;
            margin-bottom: .45rem;
        }
        .modal-bd{
            font-size: .3rem;
            color: #666;
            line-height: 1.5;
            margin-bottom: .3rem;
        }
        .modal-close{
            height: .76rem;
            line-height: .76rem;
            color: #4868af;
            border:1px solid #4868af;
            border-radius: .4rem;
            font-size: .36rem;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/page/opinionView.vue